<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-navbar></layout-navbar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">

        <!-- Page Content -->
        <div class="content container-fluid">

          <div class="crms-title row bg-white">
            <div class="col p-0">
              <h3 class="page-title m-0">
                        <span class="page-title-icon bg-gradient-primary text-white mr-2">
                          <i class="feather-grid"></i>
                        </span> Translator
                <span v-if="characterCount>0">( Zeichenverbrauch: {{characterCountThousand}} )</span>
              </h3>
            </div>
            <div class="col p-0 text-right">
              <ul class="breadcrumb bg-white float-right m-0 pl-0 pr-0">
                <li class="breadcrumb-item"><router-link to="/index">DSMS</router-link></li>
                <li class="breadcrumb-item active">Translator</li>
              </ul>
            </div>
          </div>

          <!-- Page Header -->
          <div class="page-header pt-3 mb-0 ">
            <div class="row">
              <div class="col-12 text-right">
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Content Starts -->
          <div class="row mt-5">
            <div class="col-12">
              <ChatBotComponent @finishedTranslation="getDeeplUsage"></ChatBotComponent>
            </div>
          </div>
          <!-- /Content End -->

        </div>
        <!-- /Page Content -->

      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
  import service from '@/utils/request.js';
  import ChatBotComponent from "@/components/component/ChatBotComponent.vue";
  import FingerPrintSpinner from "@/components/component/FingerPrintSpinner.vue";
  import {mapState} from "vuex";

  export default {
    components: {
      FingerPrintSpinner,
      ChatBotComponent
    },
    data() {
      return {
        characterCount: 0,
      }
    },
    created() {
    },
    computed: {
      ...mapState({
        username: state => state.user.username,
      }),
      characterCountThousand () {
        const formatter = new Intl.NumberFormat('de-DE')
        return formatter.format(this.characterCount)
      }
    },
    mounted() {
      if (['AL', 'KL'].includes(this.username)) {
        this.getDeeplUsage()
      }
    },
    updated ()
    {
    },
    methods: {
      getDeeplUsage() {
        service.request({
          url: `todos/v1/get_deepl_usage/`,
          method: 'GET',
          responseType: 'json',
        }).then((response)=>{
          this.characterCount = response.data.character_count
        })
      },
    }
  }
</script>
<style>
</style>
